

module shoppinglist {
  'use strict';

  /**
   * Services that persists and retrieves TODOs from localStorage.
   */
  export class ShoppingListService implements IShoppingListService {

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$http'
      , '$rootScope'
      , 'localStorageService'
      , 'debounce'
      , '$filter'
    ];

    private _lastRequest;
    private _lists;
    private _settings : { [key: string] : any; };
    private _debouncedUpdateQty;
    private _visibleListType : number; //type or null;


    constructor(
      private $http: ng.IHttpService,
      private $rootScope: ng.IRootScopeService,
      private localStorageService: any,
      private debounce:  navigation.IDebounceService,
      private $filter:  IOfNumber
      ) {

      this._visibleListType = null;
      this._lists = this.localStorageService.get('lists') || {};
      this._settings = this.localStorageService.get('settings') || {};     
   
    }
        
    public show(listType, target) {
      this._visibleListType = listType;
      this.$rootScope.$emit('shopping-list-show-change', this._visibleListType, target);
    }

    public hide(target) {
      this._visibleListType = null;
      this.$rootScope.$emit('shopping-list-show-change', this._visibleListType, target);
    }

    public subscribeOnShowChange(scope : ng.IScope, callback : (event:ng.IAngularEvent, visibleListType: number, target: EventTarget) => void) {
      var handler = this.$rootScope.$on('shopping-list-show-change', callback);
      if (scope) scope.$on('$destroy', handler);
    }

    public subscribeOnUpdated(scope : ng.IScope, callback : (event:ng.IAngularEvent, list : ShoppingList) => void) {
      var handler = this.$rootScope.$on('shopping-list-updated', callback);
      if (scope) scope.$on('$destroy', handler);
    }

    public getLists() :any{
      return this._lists;
    }
      
    public getList(listId) :any{
      return this._lists[listId];
    }
      
    public getLocalSetting(key, defaultValue) :any {
      if (this._settings[key] == undefined && defaultValue != undefined) this.setLocalSetting(key, defaultValue)
      return this._settings[key];
    }
      
    public setLocalSetting(key: string, value : any) :void {
      this._settings[key] = value;
      this.localStorageService.set('settings', this._settings);
    }
      
    public addToList(partid, listType : ShoppingListType, qty, onSuccess) :ng.IHttpPromise<ShoppingList> {
      return this.$http<ShoppingList>({
          method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/ShoppingList/AddToList"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          "partid" : partid
          , "listType" : listType
          , "qty": qty
        }
      }).then( 
        (response : { data : ShoppingList}) :any => { //success
          if (onSuccess) onSuccess.call(this, response.data);
        if (!this._lists[response.data.ID]) this._lists[response.data.ID] = {};
        angular.extend(this._lists[response.data.ID], response.data);
        this.localStorageService.set('lists', this._lists);
        this.$rootScope.$broadcast('cartUpdated', this._lists[response.data.ID]);
        this.$rootScope.$emit('shopping-list-updated', this._lists[response.data.ID]);
      }
      , (response : { data : ShoppingList[]}) :any => { //error
          throw "Error in 'ShoppingListService.AddToList'";
      });      
 
    }
      
    public updateQty(listid, requestid) :void {

      var parts = {}, requestid = requestid || new Date().getTime();

      this._lists[listid].Lines.forEach(function(line, index, arr) {
        parts[line.Part.ID] = line.Qty;
      });

      this.updateQtyNetwork(listid, parts, requestid);

    }
      
    public updateQtyNetwork(listid, parts, requestid) : ng.IHttpPromise<ShoppingList> {

      return this.$http<ShoppingList>({
          method: "POST"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/ShoppingList/UpdateQty"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
            "listType": this._lists[listid].Type
          , "version": this._lists[listid].Changed
        }
        , data : parts
      }).then( 
        (response : { data : ShoppingList}) :any => { //success
          //config.context.requestid
          if (!this._lists[response.data.ID]) this._lists[response.data.ID] = {};

          if (this._lastRequest != requestid) return; //there were changes in the meantime, ignore this update.

          angular.extend(this._lists[response.data.ID], response.data);
          this.localStorageService.set('lists', this._lists);
          this.$rootScope.$broadcast('cartUpdated', this._lists[response.data.ID]);
          this.$rootScope.$emit('shopping-list-updated', this._lists[response.data.ID]);
      }
      , (response : { data : ShoppingList[]}) :any => { //error
          throw "Error in 'ShoppingListService.UpdateQty'";
      });

    }

       
    public updateQtyDebounced(listid) :void {
      this._lastRequest = new Date().getTime();
      if (!this._debouncedUpdateQty) this._debouncedUpdateQty = this.debounce(this.updateQty, 500, false);
      this._debouncedUpdateQty.call(this, listid, this._lastRequest);
    }
      
    public fetchLists(id, onSuccess) :ng.IHttpPromise<ShoppingList[]> {

      return this.$http<ShoppingList[]>({
        method: "GET",
        url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/ShoppingList",
        headers: { 'Content-Type': 'application/json' }
      }).then( 
        (response : { data : ShoppingList[]}) :any => { //success
        if (onSuccess) onSuccess.call(this, response.data);

        response.data.forEach((list, index, arr) => {
          if (!this._lists[list.ID]) this._lists[list.ID] = {};
          angular.extend(this._lists[list.ID], list);
          this.calculateAvailability(this._lists[list.ID]);
          this.localStorageService.set('lists', this._lists);
          this.$rootScope.$broadcast('cartUpdated', this._lists[list.ID]);
          this.$rootScope.$emit('shopping-list-updated', this._lists[list.ID]);
        });
      }
      , (response : { data : ShoppingList[]}) :any => { //error
        throw "Error in 'ShoppingListService.FetchLists'";
      });
  
    }
      
    public getListsById(listid : string) :ng.IHttpPromise<ShoppingList> {

        return this.$http<ShoppingList>({
            method: "GET"
              , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/ShoppingList/ListsById"
              , headers: { 'Content-Type': 'application/json' }
              , params: {
                  "listId": listid
              }
        }).then((response : {data : ShoppingList}) : any => {
            return response;
        });
       
    }
      
    public shareList(listid, sendMail, eMailAddress, message, onSuccess) :ng.IHttpPromise<ShoppingList> {

      return this.$http<ShoppingList>({
          method: "POST"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/ShoppingList/ShareList"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
            "listType": this._lists[listid].Type
          , "version": this._lists[listid].Changed
          , "sendEMail" : sendMail
        }
        , data : {
          "EmailAddress" : eMailAddress || null
          , "Message" : message || null
        }
      }).then( 
        (response : { data : ShoppingList}) :any => { //success
          if (onSuccess) onSuccess.call(this, response.data);
      }
      , (response : { data : ShoppingList[]}) :any => { //error
          throw "Error in 'ShoppingListService.ShareList'";
      });

    }
      
    public appendToList(listid : string, listType : ShoppingListType) :ng.IHttpPromise<ShoppingList> {
      return this.$http<ShoppingList>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/ShoppingList/AppendToList"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          "listId": listid
          , "listType": listType
        }
      }).then( (response : {data : ShoppingList}) : any => {
        if (!this._lists[response.data.ID]) this._lists[response.data.ID] = {};

        angular.extend(this._lists[response.data.ID], response.data);
        this.localStorageService.set('lists', this._lists);
        this.$rootScope.$broadcast('cartUpdated', this._lists[response.data.ID]);
        this.$rootScope.$emit('shopping-list-updated', this._lists[response.data.ID]);
        return response;
      });
    }

      
    public checkForUpdates(serverState, onFetched) :boolean {
      var fetching = false;

      for (var i = 0; i < serverState.length; i++) {
        var list = serverState[i];
        var serverDate = new Date(list.Changed).getTime();
            
        if (!this._lists[list.ID]) {
          this.fetchLists(list.ID, onFetched);
          fetching = true;
          break;
        }
              
        var localDate = new Date(this._lists[list.ID].Changed).getTime();

        if (serverDate > localDate) {
          this.fetchLists(list.ID, onFetched);
          fetching = true;
          return true;
        }
      }


      for (var key in this._lists) {
        var existsOnServer = false;
        serverState.forEach(function(list, index, arr) {
          if (list.ID == key) {
            existsOnServer = true;
            return;
          }
        }, this);
        if (!existsOnServer) delete this._lists[key];
      }
      this.localStorageService.set('lists', this._lists);

      return fetching;
    }

          
      
    public getTotalQty(list) :number {
      if (!list) return 0;
      var total = 0;
      list.Lines.forEach(function (line, index, array) {
        total += line.Qty;
      });
      return total;
    }
      
    public calculateAvailability(list) :any {
      if (!list) return 'auf Anfrage';

      var minStatus = 99;
      var maxTimeToShip = 0;
      var maxTimeToShipPeriod = 0;

      list.Lines.forEach(function (line, index, array) {

        var tmpStatus = line.Availability.Status;
        if (line.Qty > line.Availability.QtyAvailable) tmpStatus = -1;
        minStatus = Math.min(minStatus, tmpStatus);
        maxTimeToShip = Math.max(line.Availability.TimeToShip, maxTimeToShip);
        maxTimeToShipPeriod = Math.max(line.Availability.TimeToShipPeriod, maxTimeToShipPeriod);

        line.calculatedAvailability = line.calculatedAvailability || {};

        line.calculatedAvailability.Status = tmpStatus;
        line.calculatedAvailability.TimeToShip = line.Availability.TimeToShip;
        line.calculatedAvailability.TimeToShipPeriod = line.Availability.TimeToShipPeriod;

      });

      return {
        Status: minStatus
        , TimeToShip: maxTimeToShip
        , TimeToShipPeriod: maxTimeToShipPeriod
      };
    }
      
    public getTotal(list, yourPriceEnabled : boolean) :number{
      if (!list) return 0;
      var total = 0;
      var aufAnfrage = false;
      list.Lines.forEach(function (line : ShoppingListLine, index, array) {
        aufAnfrage = line.Part.HasAufAnfrage || line.PPUAufAnfrage;
        if (yourPriceEnabled) {
          total += line.YourPPU * line.Qty;
        } else {
          total += line.PPU * line.Qty;
        }
      });
      if (aufAnfrage) return null;
      return total;
    }

            
    public getQtySummary(list) :string {      
      if (!list) return '';
      var total = {};
      list.Lines.forEach(function (line, index, array) {
        var u = pglob.RouteData.CurrentLanguage.hl == 'D' ? line.Availability.UnitDe : line.Availability.UnitEn;
        total[u] = total[u] || 0;
        total[u] += line.Qty;
      });

      var unit = "";
      for (var key in total) {
        unit += this.$filter('ofnumber')(total[key],2) + ' ' + key + ' / ';
      }
      unit = unit.replace(/ \/ $/, '');

      return unit;
    }


  }

}

